import React from 'react';
// project import
import Routes from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import './App.css'
import ErrorBoundary from 'errorboundary'

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
    
    <ThemeCustomization>
        <ScrollTop>
            <Routes />
        </ScrollTop>
    </ThemeCustomization>
);

export default App;
